import React, { useState } from 'react';
import './App.css';

function App() {
  const [selectedImage, setSelectedImage] = useState(null);
  
  const images = [
    { id: 1, src: '/images/IMG_9876.jpeg', alt: '' },
    { id: 2, src: '/images/IMG_9877.jpeg', alt: '' },
    { id: 3, src: '/images/IMG_9878.jpeg', alt: '' },
    { id: 4, src: '/images/IMG_9879.jpeg', alt: '' },
    { id: 5, src: '/images/IMG_9880.jpeg', alt: '' }
  ];

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="App">
      <div className="image-grid">
        {images.map((image) => (
          <div key={image.id} className="image-item" onClick={() => openModal(image)}>
            <img src={image.src} alt={image.alt} />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-button" onClick={closeModal}>&times;</span>
            <img src={selectedImage.src} alt={selectedImage.alt} />
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
